/*
This file was autogenerated.
Please use 'npm run sync-icons' instead of adding new icons manually
*/

export { default as access_time__filled } from './access_time-filled.svg';
export { default as access_time } from './access_time.svg';
export { default as account_circle__filled } from './account_circle-filled.svg';
export { default as account_circle } from './account_circle.svg';
export { default as account_tree__filled } from './account_tree-filled.svg';
export { default as account_tree } from './account_tree.svg';
export { default as add_box__filled } from './add_box-filled.svg';
export { default as add_box } from './add_box.svg';
export { default as add } from './add.svg';
export { default as alternate_email } from './alternate_email.svg';
export { default as analytics__filled } from './analytics-filled.svg';
export { default as analytics } from './analytics.svg';
export { default as arrow_back } from './arrow_back.svg';
export { default as arrow_circle_down__filled } from './arrow_circle_down-filled.svg';
export { default as arrow_circle_down } from './arrow_circle_down.svg';
export { default as arrow_circle_up__filled } from './arrow_circle_up-filled.svg';
export { default as arrow_circle_up } from './arrow_circle_up.svg';
export { default as arrow_down } from './arrow_down.svg';
export { default as arrow_drop_down } from './arrow_drop_down.svg';
export { default as arrow_drop_up } from './arrow_drop_up.svg';
export { default as arrow_forward } from './arrow_forward.svg';
export { default as arrow_left } from './arrow_left.svg';
export { default as arrow_right } from './arrow_right.svg';
export { default as arrow_up } from './arrow_up.svg';
export { default as arrows_diagrams } from './arrows_diagrams.svg';
export { default as assignment_ind__filled } from './assignment_ind-filled.svg';
export { default as assignment_ind } from './assignment_ind.svg';
export { default as assignment__filled } from './assignment-filled.svg';
export { default as assignment } from './assignment.svg';
export { default as attach_file } from './attach_file.svg';
export { default as award_medal__filled } from './award_medal-filled.svg';
export { default as award_medal } from './award_medal.svg';
export { default as balloon } from './balloon.svg';
export { default as build } from './build.svg';
export { default as business__filled } from './business-filled.svg';
export { default as business } from './business.svg';
export { default as building_apartment_two__filled } from './building_apartment_two-filled.svg';
export { default as building_apartment_two } from './building_apartment_two.svg';
export { default as bubble_chart__filled } from './bubble_chart-filled.svg';
export { default as bubble_chart } from './bubble_chart.svg';
export { default as cake__filled } from './cake-filled.svg';
export { default as cake } from './cake.svg';
export { default as calendar_today__filled } from './calendar_today-filled.svg';
export { default as calendar_today } from './calendar_today.svg';
export { default as calendar_default__filled } from './calendar_default-filled.svg';
export { default as calendar_default } from './calendar_default.svg';
export { default as campaign } from './campaign.svg';
export { default as chat__filled } from './chat-filled.svg';
export { default as chat } from './chat.svg';
export { default as check_box } from './check_box.svg';
export { default as check_box__filled } from './check_box-filled.svg';
export { default as check_circle__filled } from './check_circle-filled.svg';
export { default as check_circle } from './check_circle.svg';
export { default as check } from './check.svg';
export { default as chevron_left } from './chevron_left.svg';
export { default as chevron_right } from './chevron_right.svg';
export { default as close_round__filled } from './close_round-filled.svg';
export { default as close } from './close.svg';
export { default as clipboard_text__filled } from './clipboard_text-filled.svg';
export { default as clipboard_text } from './clipboard_text.svg';
export { default as cockade } from './cockade.svg';
export { default as coffee__filled } from './coffee-filled.svg';
export { default as coffee } from './coffee.svg';
export { default as contact_support__filled } from './contact_support-filled.svg';
export { default as contact_support } from './contact_support.svg';
export { default as content_copy } from './content_copy.svg';
export { default as create__filled } from './create-filled.svg';
export { default as create } from './create.svg';
export { default as dashboard } from './dashboard.svg';
export { default as date_end__filled } from './date_end-filled.svg';
export { default as date_end } from './date_end.svg';
export { default as date_start__filled } from './date_start-filled.svg';
export { default as date_start } from './date_start.svg';
export { default as delete__filled } from './delete-filled.svg';
export { default as delete } from './delete.svg';
export { default as document__filled } from './document-filled.svg';
export { default as document } from './document.svg';
export { default as done_all } from './done_all.svg';
export { default as download } from './download.svg';
export { default as draft__filled } from './draft-filled.svg';
export { default as draft } from './draft.svg';
export { default as drag_handle } from './drag_handle.svg';
export { default as edit__filled } from './edit-filled.svg';
export { default as edit } from './edit.svg';
export { default as email__filled } from './email-filled.svg';
export { default as email } from './email.svg';
export { default as event_busy__filled } from './event_busy-filled.svg';
export { default as event_busy } from './event_busy.svg';
export { default as event__filled } from './event-filled.svg';
export { default as event } from './event.svg';
export { default as expand_less } from './expand_less.svg';
export { default as expand_more } from './expand_more.svg';
export { default as extension__filled } from './extension-filled.svg';
export { default as extension } from './extension.svg';
export { default as favorite__filled } from './favorite-filled.svg';
export { default as favorite } from './favorite.svg';
export { default as filter_alt__filled } from './filter_alt-filled.svg';
export { default as filter_alt } from './filter_alt.svg';
export { default as filter_none } from './filter_none.svg';
export { default as flight } from './flight.svg';
export { default as folder__filled } from './folder-filled.svg';
export { default as folder } from './folder.svg';
export { default as font_bold } from './font_bold.svg';
export { default as font_italic } from './font_italic.svg';
export { default as format_list_numbered } from './format_list_numbered.svg';
export { default as format_paint } from './format_paint.svg';
export { default as gif } from './gif.svg';
export { default as gift } from './gift.svg';
export { default as grid_view__filled } from './grid_view-filled.svg';
export { default as grid_view } from './grid_view.svg';
export { default as group_add__filled } from './group_add-filled.svg';
export { default as group_add } from './group_add.svg';
export { default as group__filled } from './group-filled.svg';
export { default as group } from './group.svg';
export { default as groups } from './groups.svg';
export { default as heart_hands } from './heart_hands.svg';
export { default as heart_pulse } from './heart_pulse.svg';
export { default as help__filled } from './help-filled.svg';
export { default as help } from './help.svg';
export { default as hierarchy } from './help.svg';
export { default as highfive__filled } from './highfive-filled.svg';
export { default as highfive__filled__white } from './highfive-filled-white.svg';
export { default as highfive } from './highfive.svg';
export { default as home__filled } from './home-filled.svg';
export { default as home } from './home.svg';
export { default as home_h_line__filled } from './home_h_line-filled.svg';
export { default as home_h_line } from './home_h_line.svg';
export { default as how_to_reg__filled } from './how_to_reg-filled.svg';
export { default as how_to_reg } from './how_to_reg.svg';
export { default as image__filled } from './image-filled.svg';
export { default as image } from './image.svg';
export { default as incognito } from './incognito.svg';
export { default as info__filled } from './info-filled.svg';
export { default as info } from './info.svg';
export { default as insert_emoticon_reaction } from './insert_emoticon_reaction.svg';
export { default as insert_emoticon } from './insert_emoticon.svg';
export { default as insert_image } from './insert_image.svg';
export { default as insert_link } from './insert_link.svg';
export { default as insert_table } from './insert_table.svg';
export { default as link_off } from './link-off.svg';
export { default as insert_video } from './insert_video.svg';
export { default as inventory__filled } from './inventory-filled.svg';
export { default as inventory } from './inventory.svg';
export { default as ios_share } from './ios_share.svg';
export { default as language } from './language.svg';
export { default as launch } from './launch.svg';
export { default as library_add } from './library_add.svg';
export { default as lightbulb } from './lightbulb.svg';
export { default as linear_scale } from './linear_scale.svg';
export { default as local_movies } from './local_movies.svg';
export { default as local_police } from './local_police.svg';
export { default as lock__filled } from './lock-filled.svg';
export { default as lock } from './lock.svg';
export { default as logout__filled } from './logout-filled.svg';
export { default as logout } from './logout.svg';
export { default as manager } from './manager.svg';
export { default as map } from './map.svg';
export { default as mark_email_read } from './mark_email_read.svg';
export { default as menu_circle__filled } from './menu_circle-filled.svg';
export { default as menu_circle } from './menu_circle.svg';
export { default as menu } from './menu.svg';
export { default as mic } from './mic.svg';
export { default as minus } from './minus.svg';
export { default as modules } from './modules.svg';
export { default as money_fill } from './money_fill.svg';
export { default as more_horiz } from './more_horiz.svg';
export { default as more_vert } from './more_vert.svg';
export { default as nightlight } from './nightlight.svg';
export { default as notebook__filled } from './notebook-filled.svg';
export { default as notebook } from './notebook.svg';
export { default as not_interested } from './not_interested.svg';
export { default as notifications_off } from './notifications_off.svg';
export { default as notifications__filled } from './notifications-filled.svg';
export { default as notifications } from './notifications.svg';
export { default as number__filled } from './number-filled.svg';
export { default as number } from './number.svg';
export { default as paid } from './paid.svg';
export { default as pending_actions } from './pending_actions.svg';
export { default as person_add__filled } from './person_add-filled.svg';
export { default as person_add } from './person_add.svg';
export { default as person_remove__filled } from './person_remove-filled.svg';
export { default as person_remove } from './person_remove.svg';
export { default as person__filled } from './person-filled.svg';
export { default as person } from './person.svg';
export { default as phone__filled } from './phone-filled.svg';
export { default as phone } from './phone.svg';
export { default as photo_camera__filled } from './photo_camera-filled.svg';
export { default as photo_camera } from './photo_camera.svg';
export { default as place__filled } from './place-filled.svg';
export { default as place } from './place.svg';
export { default as plant } from './plant.svg';
export { default as play_arrow } from './play_arrow.svg';
export { default as play_circle__filled } from './play_circle-filled.svg';
export { default as play_circle } from './play_circle.svg';
export { default as playlist_add_check } from './playlist_add_check.svg';
export { default as playlist_add } from './playlist_add.svg';
export { default as presentation_trendline_up__filled } from './presentation_trendline_up-filled.svg';
export { default as presentation_trendline_up } from './presentation_trendline_up.svg';
export { default as poll__filled } from './poll-filled.svg';
export { default as poll } from './poll.svg';
export { default as print } from './print.svg';
export { default as public__filled } from './public-filled.svg';
export { default as public } from './public.svg';
export { default as push_pin_off } from './push_pin_off.svg';
export { default as push_pin } from './push_pin.svg';
export { default as qr_code } from './qr_code.svg';
export { default as radio_button_checked } from './radio_button_checked.svg';
export { default as radio_button_unchecked } from './radio_button_unchecked.svg';
export { default as redo } from './redo.svg';
export { default as refresh } from './refresh.svg';
export { default as remove_circle_outline } from './remove_circle_outline.svg';
export { default as reply__filled } from './reply-filled.svg';
export { default as reply } from './reply.svg';
export { default as required } from './required.svg';
export { default as restore } from './restore.svg';
export { default as school__filled } from './school-filled.svg';
export { default as school } from './school.svg';
export { default as search } from './search.svg';
export { default as send__filled } from './send-filled.svg';
export { default as send } from './send.svg';
export { default as settings__filled } from './settings-filled.svg';
export { default as settings } from './settings.svg';
export { default as shield__filled } from './shield-filled.svg';
export { default as shield } from './shield.svg';
export { default as sidebar } from './sidebar.svg';
export { default as smile } from './smile.svg';
export { default as smile2 } from './smile2.svg';
export { default as sort } from './sort.svg';
export { default as sparks } from './sparks.svg';
export { default as speech_cloud } from './speech_cloud.svg';
export { default as star_off } from './star_off.svg';
export { default as star__filled } from './star-filled.svg';
export { default as star } from './star.svg';
export { default as storefront__filled } from './storefront-filled.svg';
export { default as storefront } from './storefront.svg';
export { default as subdirectory_arrow_right } from './subdirectory_arrow_right.svg';
export { default as subject } from './subject.svg';
export { default as swap_horizontal_circle__filled } from './swap_horizontal_circle-filled.svg';
export { default as swap_horizontal_circle } from './swap_horizontal_circle.svg';
export { default as sync_alt__filled } from './sync_alt-filled.svg';
export { default as sync_alt } from './sync_alt.svg';
export { default as sync } from './sync.svg';
export { default as team } from './team.svg';
export { default as text_bullet_list } from './text-bullet-list.svg';
export { default as text_link } from './text-link.svg';
export { default as text_numbered_list } from './text-numbered-list.svg';
export { default as text_strikethrough } from './text_strikethrough.svg';
export { default as text_underline } from './text-underline.svg';
export { default as thumb_up } from './thumb_up.svg';
export { default as timeline } from './timeline.svg';
export { default as to_the_center } from './to_the_center.svg';
export { default as unarchive__filled } from './unarchive-filled.svg';
export { default as unarchive } from './unarchive.svg';
export { default as undo } from './undo.svg';
export { default as upload } from './upload.svg';
export { default as user_two__filled } from './user_two-filled.svg';
export { default as user_two } from './user_two.svg';
export { default as user_arrow_right__filled } from './user_arrow_right-filled.svg';
export { default as user_arrow_right } from './user_arrow_right.svg';
export { default as videocam__filled } from './videocam-filled.svg';
export { default as videocam } from './videocam.svg';
export { default as visibility_off } from './visibility_off.svg';
export { default as visibility__filled } from './visibility-filled.svg';
export { default as visibility } from './visibility.svg';
export { default as volume_off__filled } from './volume_off-filled.svg';
export { default as volume_off } from './volume_off.svg';
export { default as volume_up__filled } from './volume_up-filled.svg';
export { default as volume_up } from './volume_up.svg';
export { default as warning } from './warning.svg';
export { default as work } from './work.svg';
export { default as youtube__filled } from './youtube-filled.svg';
export { default as youtube } from './youtube.svg';
export { default as zoom_in } from './zoom_in.svg';
export { default as crown } from './crown.svg';
export { default as inbox__filled } from './inbox-filled.svg';
export { default as edit_pencil } from './edit-pencil.svg';
export { default as pin } from './pin.svg';
export { default as file_02_bar_graph } from './file-02-bar-graph.svg';
export { default as file_02_arrow_down__filled } from './file-02-arrow-down-filled.svg';
export { default as file_02_check__filled } from './file-02-check-filled.svg';
export { default as file_02_check } from './file-02-check.svg';
export { default as file_02_bolt__filled } from './file-02-bolt-filled.svg';
export { default as file_02_bolt } from './file-02-bolt.svg';
export { default as briefcase_job } from './briefcase-job.svg';
export { default as bar_chart } from './bar_chart.svg';
export { default as bar_chart__filled } from './bar_chart-filled.svg';
export { default as check_tick_circle } from './check-tick-circle-broken.svg';
export { default as dragable_six_dots } from './dragable-six-dots.svg';
export { default as chat_default } from './chat-default.svg';
export { default as list_long } from './list-long.svg';
export { default as slider_long } from './slider-long.svg';
export { default as arrow_down_default } from './arrow_down_default.svg';
export { default as three_dot_horiz } from './three_dot_horiz.svg';
export { default as list_number } from './list_number.svg';
export { default as flag } from './flag.svg';
export { default as swap_verticle } from './swap-verticle.svg';
export { default as check_tick } from './check-tick.svg';
export { default as circle_check } from './circle-check.svg';
export { default as circle } from './circle.svg';
export { default as community_icon } from './community.svg';
export { default as hashtag_icon } from './hashtag.svg';
export { default as eye_off } from './eye-off.svg';
export { default as coffee_cup } from './coffee.svg';
export { default as timer } from './timer.svg';
export { default as frame } from './frame.svg';
export { default as grid_table } from './grid-table.svg';
export { default as grid_table_view } from './grid-table-view.svg';
export { default as table_view } from './table-view.svg';
export { default as eye_on } from './eye-on.svg';
export { default as csv_export } from './csv.svg';
export { default as xls_export } from './xls.svg';
export { default as pdf_export } from './pdf.svg';
export { default as side_bar } from './side-bar.svg';
export { default as bag } from './bag.svg';
export { default as high_five_like } from './high-five-like.svg';
export { default as reaction } from './reaction.svg';
export { default as chat_default_transparent } from './chat-default-transparent.svg';
export { default as reaction__filled } from './reaction-filled.svg';
export { default as start_evaluation } from './start-evaluation.svg';
export { default as stop } from './stop.svg';
export { default as timer_default } from './timer-default.svg';
export { default as pencil_edit } from './pencil-edit.svg';
export { default as file_text__filled } from './file-text-filled.svg';
export { default as email_template } from './email-template.svg';
export { default as ic_notification_calendar_cleaned } from './ic_notification_calendar_cleaned.svg';
export { default as database } from './database.svg';
export { default as file_text } from './file-text.svg';
export { default as translate } from './translate.svg';
export { default as chat_plus } from './chat-plus.svg';
export { default as reminder_anticlockwise } from './reminder-anticlockwise.svg';
export { default as thumb_down } from './thumb-down.svg';
export { default as announcement } from './announcement.svg';
export { default as share_icon } from './share.svg';
export { default as copy_default } from './copy-default.svg';
export { default as copy_default__filled } from './copy-default-filled.svg';
export { default as magic_wand } from './magic-wand.svg';
export { default as bot } from './bot.svg';
export { default as message_default } from './message-default.svg';
export { default as sparkle_ai } from './sparkle-ai.svg';
export { default as sparkle_ai__filled } from './sparkle-ai-filled.svg';
export { default as chat_chatting } from './chat-chatting.svg';
export { default as chat_chatting__filled } from './chat-chatting-filled.svg';
export { default as chat_check } from './chat-check.svg';
export { default as chat_check__filled } from './chat-check-filled.svg';
export { default as filter_horizontal } from './filter-horizontal.svg';
export { default as filter_horizontal__filled } from './filter-horizontal-filled.svg';
export { default as piechart } from './piechart.svg';
export { default as piechart__filled } from './piechart-filled.svg';
export { default as list_plus } from './list-plus.svg';
export { default as list_text_wrap } from './list-text-wrap.svg';
export { default as check_tick_double } from './check-tick-double.svg';
export { default as copy } from './copy-default.svg';
export { default as course } from './course.svg';
export { default as clock_filled } from './clock.svg';
export { default as translator } from './translator.svg';
export { default as move_to_folder } from './folder-move-in.svg';
export { default as email_settings } from './email-setting.svg';
export { default as grid } from './grid.svg';
export { default as general_settings } from './general-settings.svg';
export { default as branding } from './branding.svg';
export { default as integration } from './integration.svg';
export { default as rss_feed } from './rss-square.svg';
export { default as rss_feed__filled } from './rss-square-filled.svg';
export { default as email_settings__filled } from './email-setting-filled.svg';
export { default as grid__filled } from './grid-filled.svg';
export { default as general_settings__filled } from './general-settings-filled.svg';
export { default as branding__filled } from './branding-filled.svg';
export { default as integration__filled } from './integration-filled.svg';
export { default as long_list } from './long-list.svg';
export { default as question_type } from './question-type.svg';
export { default as heart__filled } from './heart-filled.svg';
export { default as laugh_emoji } from './laugh-emoji.svg';
export { default as party_popper } from './party-popper.svg';
export { default as support_heart } from './support-heart.svg';
export { default as translate_in_progress } from './translation-blue.svg';
export { default as translate_error } from './translation-red.svg';
export { default as sparkle_ai_color } from './sparkle-ai-color.svg';
export { default as chevron_sort_vertical } from './chevron-sort-vertical.svg';
export { default as link_slant } from './link-slant.svg';
export { default as light_theme } from './light-theme.svg';
export { default as dark_theme } from './dark-theme.svg';
export { default as system_theme } from './system-theme.svg';
export { default as list_remove } from './list-remove.svg';
export { default as multiple_choice } from './multiple-choice.svg';
export { default as image_hotspot } from './image-hotspot.svg';
export { default as pointer_cursor } from './pointer-cursor.svg';
export { default as queue } from './queue.svg';
export { default as webhook } from './webhook.svg';
export { default as pause } from './pause.svg';
export { default as play_arrow__filled } from './play_arrow-filled.svg';
export { default as chart_line } from './line-chart.svg';
export { default as chart_bar } from './bar-chart.svg';
export { default as chart_stacked } from './stack-chart.svg';
export { default as chart_area } from './area-chart.svg';
export { default as chart_pie } from './pie-chart.svg';
export { default as chart_gauge } from './gauge-chart.svg';
export { default as arrow_turn_up_right } from './arrow-turn-up-right.svg';
